var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeamlessDataMigration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 222,
    viewBox: "0 0 357 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6219_98153)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.957 23.8845C158.639 29.8338 142.176 42.5697 129.21 54.4453C102.208 79.1741 98.1773 84.3734 64.8651 105.134C45.4506 117.235 30.1426 127.468 22.6013 141.154C1.4154 179.601 26.6503 221.126 79.5266 221.126H294.476C294.476 221.126 319.759 221.653 338.212 201.104C400.748 131.457 297.027 -17.7052 175.957 23.8845Z",
    fill: "#EFF6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6219_98153",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 0,
    width: 125,
    height: 66
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.484 23.1184C269.656 23.1184 278.713 32.6175 278.713 44.3343C278.713 45.6617 278.596 46.9615 278.373 48.2222C282.682 48.5213 286.091 52.2804 286.091 56.877C286.091 61.4735 282.39 65.5501 277.821 65.5501H169.05C158.532 65.2372 160.745 49.0803 171.422 49.2966C170.872 36.6757 181.441 22.0418 200.326 26.6475C200.65 23.59 201.716 19.028 204.083 14.8065C209.05 5.94697 218.231 0 228.74 0C242.309 0 253.669 9.91315 256.6 23.2104C257.221 23.1506 257.85 23.1184 258.484 23.1184Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6219_98153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.091 0H158.531V65.5501H286.091V0Z",
    fill: "url(#paint0_linear_6219_98153)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6219_98153",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 0,
    width: 125,
    height: 66
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.867 23.1184C261.039 23.1184 270.096 32.6175 270.096 44.3343C270.096 45.6617 269.979 46.9615 269.756 48.2222C274.065 48.5213 277.474 52.2804 277.474 56.877C277.474 61.4735 273.773 65.5501 269.204 65.5501H160.433C149.914 65.2372 152.128 49.0803 162.805 49.2966C162.255 36.6757 172.824 22.0418 191.709 26.6475C192.033 23.59 193.098 19.028 195.466 14.8065C200.433 5.94697 209.614 0 220.123 0C233.692 0 245.052 9.91315 247.983 23.2104C248.604 23.1506 249.232 23.1184 249.867 23.1184Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6219_98153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.482 0H149.922V65.5501H277.482V0Z",
    fill: "url(#paint1_linear_6219_98153)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.841 87.3917H52.372C46.8345 87.3917 42.3047 91.9215 42.3047 97.459V187.494V188.775C42.3047 194.313 46.8345 198.843 52.372 198.843H206.841C212.379 198.843 216.909 194.313 216.909 188.775V97.459C216.909 91.9215 212.379 87.3917 206.841 87.3917Z",
    fill: "#5C90D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.63 87.3917H57.161C51.6236 87.3917 47.0938 91.9215 47.0938 97.459V187.494V188.775C47.0938 194.313 51.6236 198.843 57.161 198.843H211.63C217.168 198.843 221.698 194.313 221.698 188.775V97.459C221.698 91.9215 217.168 87.3917 211.63 87.3917Z",
    fill: "#7BA9E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0883 92.92H217.705C217.728 92.92 217.746 92.9361 217.746 92.9545V182.983C217.746 183.001 217.728 183.017 217.705 183.017H51.0883C51.0653 183.017 51.0469 183.001 51.0469 182.983V92.9545C51.0469 92.9361 51.0653 92.92 51.0883 92.92Z",
    fill: "#355298"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.039 92.9545H51.0469V183.017H114.039V92.9545Z",
    fill: "#2A4589"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.719 197.207C120.011 210.028 118.133 213.27 105.133 220.576H162.764C149.764 213.27 147.887 210.028 147.178 197.207L133.947 196.165L120.717 197.207H120.719Z",
    fill: "#7BA9E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.394 186.572C136.265 186.572 137.781 188.088 137.781 189.958C137.781 191.828 136.265 193.344 134.394 193.344C132.524 193.344 131.008 191.828 131.008 189.958C131.008 188.088 132.524 186.572 134.394 186.572Z",
    fill: "#B1CBEF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M147.699 198.843H120.281V202.489H147.699V198.843Z",
    fill: "#2A4589"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M346.847 220.576H18.0703V221.124H346.847V220.576Z",
    fill: "#000446"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.426 108.476L154.734 103.523H127.875V108.476V158.183H196.535V108.476H157.426Z",
    fill: "#F79646"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.332 110.733H130.07V158.183H194.332V110.733Z",
    fill: "#C3DCFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.266 113.156H195.195L194.33 158.183H130.069L129.266 113.156Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.586 115.797H198.523L196.531 158.182H127.87L125.586 115.797Z",
    fill: "#FBB44A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.815 141.729L152.615 141.2C152.951 140.979 153.101 140.56 152.976 140.178C152.735 139.44 152.592 138.685 152.539 137.926C152.512 137.526 152.217 137.192 151.822 137.114L150.881 136.921C150.393 136.822 150.075 136.346 150.174 135.858L150.542 134.054C150.641 133.566 151.12 133.251 151.608 133.35L152.548 133.541C152.944 133.622 153.344 133.431 153.526 133.072C153.869 132.393 154.299 131.756 154.81 131.172C155.075 130.868 155.1 130.426 154.877 130.09L154.348 129.287C154.071 128.871 154.187 128.312 154.603 128.036L156.137 127.021C156.554 126.745 157.113 126.86 157.389 127.277L157.918 128.077C158.139 128.413 158.558 128.563 158.939 128.438C159.678 128.197 160.433 128.054 161.189 128.001C161.592 127.974 161.923 127.679 162.004 127.284L162.195 126.343C162.294 125.855 162.77 125.537 163.26 125.639L165.064 126.004C165.551 126.103 165.866 126.582 165.768 127.07L165.577 128.011C165.496 128.404 165.687 128.807 166.046 128.988C166.722 129.333 167.362 129.761 167.946 130.272C168.248 130.537 168.692 130.562 169.027 130.341L169.828 129.81C170.244 129.534 170.804 129.649 171.08 130.065L172.094 131.599C172.37 132.016 172.255 132.575 171.839 132.851L171.038 133.38C170.702 133.603 170.553 134.02 170.677 134.402C170.919 135.138 171.061 135.895 171.114 136.652C171.142 137.054 171.436 137.385 171.83 137.466L172.773 137.657C173.261 137.756 173.576 138.234 173.477 138.722L173.111 140.526C173.012 141.016 172.534 141.329 172.046 141.23L171.105 141.036C170.709 140.956 170.309 141.147 170.127 141.506C169.782 142.182 169.354 142.822 168.846 143.406C168.581 143.707 168.556 144.154 168.777 144.487L169.306 145.288C169.582 145.704 169.467 146.263 169.05 146.539L167.516 147.556C167.102 147.83 166.541 147.715 166.264 147.301L165.735 146.498C165.514 146.162 165.096 146.013 164.712 146.137C163.975 146.378 163.219 146.521 162.462 146.574C162.061 146.601 161.728 146.896 161.647 147.292L161.456 148.233C161.357 148.723 160.879 149.038 160.391 148.939L158.587 148.571C158.1 148.472 157.782 147.996 157.884 147.506L158.074 146.562C158.155 146.169 157.964 145.766 157.605 145.585C156.926 145.242 156.287 144.814 155.705 144.303C155.401 144.039 154.959 144.013 154.624 144.236L153.821 144.766C153.404 145.042 152.845 144.927 152.569 144.51L151.555 142.976C151.279 142.559 151.394 142 151.81 141.727M158.185 140.712C159.611 142.251 161.926 142.723 163.84 141.865C167.001 140.445 167.822 136.408 165.468 133.866C164.042 132.326 161.73 131.855 159.816 132.715C156.655 134.135 155.831 138.172 158.185 140.714V140.712Z",
    fill: "#F79646"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.263 65.5501L225.293 43.7315H236.653L221.092 22.8516L205.531 43.7315H216.894L216.864 65.5501H225.263Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.406 166.027H134.184C133.563 166.027 132.999 166.216 132.592 166.52C132.183 166.823 131.93 167.242 131.93 167.7V170.87C131.93 171.33 132.183 171.749 132.592 172.05C133.002 172.354 133.565 172.543 134.184 172.543H172.406V166.027Z",
    fill: "#77BB2C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.406 166.027V172.543H188.388C189.007 172.543 189.573 172.354 189.98 172.05C190.39 171.747 190.643 171.328 190.643 170.87V167.7C190.643 167.24 190.39 166.821 189.98 166.52C189.571 166.216 189.007 166.027 188.388 166.027H172.406Z",
    fill: "#C3DCFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.442 86.9109H249.539V220.576H313.442V86.9109Z",
    fill: "#B1D2FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M310.588 89.805H252.391V212.869H310.588V89.805Z",
    fill: "#7BA9E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 199.825H309.39C310.047 199.825 310.588 200.364 310.588 201.024V211.673C310.588 212.331 310.05 212.872 309.39 212.872H253.589C252.931 212.872 252.391 212.333 252.391 211.673V201.024C252.391 200.366 252.929 199.825 253.589 199.825Z",
    fill: "#2A4589"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 203.805H254.453V204.617H256.411V203.805Z",
    fill: "#B9D0F1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 205.349H254.453V206.161H256.411V205.349Z",
    fill: "#B9D0F1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 206.89H254.453V207.702H256.411V206.89Z",
    fill: "#B9D0F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 208.434H254.453V209.246H256.411V208.434Z",
    fill: "#B9D0F1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 209.978H254.453V210.79H256.411V209.978Z",
    fill: "#B9D0F1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 203.805H257.273V204.617H259.231V203.805Z",
    fill: "#B9D0F1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 203.805H260.078V204.617H262.036V203.805Z",
    fill: "#B9D0F1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 203.805H262.891V204.617H264.848V203.805Z",
    fill: "#B9D0F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 203.805H265.703V204.617H267.661V203.805Z",
    fill: "#B9D0F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 203.805H268.508V204.617H270.466V203.805Z",
    fill: "#B9D0F1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 203.805H271.32V204.617H273.278V203.805Z",
    fill: "#B9D0F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 205.349H257.273V206.161H259.231V205.349Z",
    fill: "#B9D0F1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 205.349H260.078V206.161H262.036V205.349Z",
    fill: "#B9D0F1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 205.349H262.891V206.161H264.848V205.349Z",
    fill: "#B9D0F1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 205.349H265.703V206.161H267.661V205.349Z",
    fill: "#B9D0F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 205.349H268.508V206.161H270.466V205.349Z",
    fill: "#B9D0F1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 205.349H271.32V206.161H273.278V205.349Z",
    fill: "#B9D0F1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 206.89H257.273V207.702H259.231V206.89Z",
    fill: "#B9D0F1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 206.89H260.078V207.702H262.036V206.89Z",
    fill: "#B9D0F1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 206.89H262.891V207.702H264.848V206.89Z",
    fill: "#B9D0F1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 206.89H265.703V207.702H267.661V206.89Z",
    fill: "#B9D0F1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 206.89H268.508V207.702H270.466V206.89Z",
    fill: "#B9D0F1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 206.89H271.32V207.702H273.278V206.89Z",
    fill: "#B9D0F1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 208.434H257.273V209.246H259.231V208.434Z",
    fill: "#B9D0F1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 208.434H260.078V209.246H262.036V208.434Z",
    fill: "#B9D0F1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 208.434H262.891V209.246H264.848V208.434Z",
    fill: "#B9D0F1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 208.434H265.703V209.246H267.661V208.434Z",
    fill: "#B9D0F1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 208.434H268.508V209.246H270.466V208.434Z",
    fill: "#B9D0F1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 208.434H271.32V209.246H273.278V208.434Z",
    fill: "#B9D0F1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 209.978H257.273V210.79H259.231V209.978Z",
    fill: "#B9D0F1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 209.978H260.078V210.79H262.036V209.978Z",
    fill: "#B9D0F1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 209.978H262.891V210.79H264.848V209.978Z",
    fill: "#B9D0F1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 209.978H265.703V210.79H267.661V209.978Z",
    fill: "#B9D0F1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 209.978H268.508V210.79H270.466V209.978Z",
    fill: "#B9D0F1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 209.978H271.32V210.79H273.278V209.978Z",
    fill: "#B9D0F1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 203.805H277V204.617H278.958V203.805Z",
    fill: "#E06B6C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 203.805H279.812V204.617H281.77V203.805Z",
    fill: "#E06B6C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 203.805H282.617V204.617H284.575V203.805Z",
    fill: "#E06B6C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 203.805H290.148V204.617H292.106V203.805Z",
    fill: "#E06B6C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 203.805H292.961V204.617H294.919V203.805Z",
    fill: "#E06B6C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 203.805H295.766V204.617H297.723V203.805Z",
    fill: "#E06B6C"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M249.541 86.9109H240.242V220.576H249.541V86.9109Z",
    fill: "#7BA9E3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 184.108H309.39C310.047 184.108 310.588 184.646 310.588 185.306V195.956C310.588 196.614 310.05 197.154 309.39 197.154H253.589C252.931 197.154 252.391 196.616 252.391 195.956V185.306C252.391 184.648 252.929 184.108 253.589 184.108Z",
    fill: "#2A4589"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 168.39H309.39C310.047 168.39 310.588 168.928 310.588 169.589V180.238C310.588 180.896 310.05 181.437 309.39 181.437H253.589C252.931 181.437 252.391 180.898 252.391 180.238V169.589C252.391 168.931 252.929 168.39 253.589 168.39Z",
    fill: "#2A4589"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 152.673H309.39C310.047 152.673 310.588 153.211 310.588 153.871V164.521C310.588 165.178 310.05 165.719 309.39 165.719H253.589C252.931 165.719 252.391 165.181 252.391 164.521V153.871C252.391 153.213 252.929 152.673 253.589 152.673Z",
    fill: "#2A4589"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 136.958H309.39C310.047 136.958 310.588 137.496 310.588 138.156V148.805C310.588 149.463 310.05 150.004 309.39 150.004H253.589C252.931 150.004 252.391 149.466 252.391 148.805V138.156C252.391 137.498 252.929 136.958 253.589 136.958Z",
    fill: "#2A4589"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 121.24H309.39C310.047 121.24 310.588 121.778 310.588 122.439V133.088C310.588 133.746 310.05 134.287 309.39 134.287H253.589C252.931 134.287 252.391 133.748 252.391 133.088V122.439C252.391 121.781 252.929 121.24 253.589 121.24Z",
    fill: "#2A4589"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 188.088H254.453V188.9H256.411V188.088Z",
    fill: "#B9D0F1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 172.37H254.453V173.182H256.411V172.37Z",
    fill: "#B9D0F1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 156.653H254.453V157.465H256.411V156.653Z",
    fill: "#B9D0F1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 140.937H254.453V141.75H256.411V140.937Z",
    fill: "#B9D0F1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 125.22H254.453V126.032H256.411V125.22Z",
    fill: "#B9D0F1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 189.631H254.453V190.443H256.411V189.631Z",
    fill: "#B9D0F1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 173.914H254.453V174.726H256.411V173.914Z",
    fill: "#B9D0F1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 158.196H254.453V159.008H256.411V158.196Z",
    fill: "#B9D0F1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 142.481H254.453V143.293H256.411V142.481Z",
    fill: "#B9D0F1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 126.764H254.453V127.576H256.411V126.764Z",
    fill: "#B9D0F1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 191.175H254.453V191.987H256.411V191.175Z",
    fill: "#B9D0F1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 175.458H254.453V176.27H256.411V175.458Z",
    fill: "#B9D0F1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 159.74H254.453V160.552H256.411V159.74Z",
    fill: "#B9D0F1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 144.023H254.453V144.835H256.411V144.023Z",
    fill: "#B9D0F1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 128.307H254.453V129.119H256.411V128.307Z",
    fill: "#B9D0F1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 192.719H254.453V193.531H256.411V192.719Z",
    fill: "#B9D0F1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 177.001H254.453V177.813H256.411V177.001Z",
    fill: "#B9D0F1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 161.284H254.453V162.096H256.411V161.284Z",
    fill: "#B9D0F1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 145.566H254.453V146.378H256.411V145.566Z",
    fill: "#B9D0F1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 129.851H254.453V130.663H256.411V129.851Z",
    fill: "#B9D0F1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 194.26H254.453V195.072H256.411V194.26Z",
    fill: "#B9D0F1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 178.545H254.453V179.357H256.411V178.545Z",
    fill: "#B9D0F1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 162.827H254.453V163.639H256.411V162.827Z",
    fill: "#B9D0F1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 147.11H254.453V147.922H256.411V147.11Z",
    fill: "#B9D0F1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 131.392H254.453V132.204H256.411V131.392Z",
    fill: "#B9D0F1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 188.088H257.273V188.9H259.231V188.088Z",
    fill: "#B9D0F1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 172.37H257.273V173.182H259.231V172.37Z",
    fill: "#B9D0F1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 156.653H257.273V157.465H259.231V156.653Z",
    fill: "#B9D0F1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 140.937H257.273V141.75H259.231V140.937Z",
    fill: "#B9D0F1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 125.22H257.273V126.032H259.231V125.22Z",
    fill: "#B9D0F1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 188.088H260.078V188.9H262.036V188.088Z",
    fill: "#B9D0F1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 172.37H260.078V173.182H262.036V172.37Z",
    fill: "#B9D0F1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 156.653H260.078V157.465H262.036V156.653Z",
    fill: "#B9D0F1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 140.937H260.078V141.75H262.036V140.937Z",
    fill: "#B9D0F1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 125.22H260.078V126.032H262.036V125.22Z",
    fill: "#B9D0F1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 188.088H262.891V188.9H264.848V188.088Z",
    fill: "#B9D0F1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 172.37H262.891V173.182H264.848V172.37Z",
    fill: "#B9D0F1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 156.653H262.891V157.465H264.848V156.653Z",
    fill: "#B9D0F1"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 140.937H262.891V141.75H264.848V140.937Z",
    fill: "#B9D0F1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 125.22H262.891V126.032H264.848V125.22Z",
    fill: "#B9D0F1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 188.088H265.703V188.9H267.661V188.088Z",
    fill: "#B9D0F1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 172.37H265.703V173.182H267.661V172.37Z",
    fill: "#B9D0F1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 156.653H265.703V157.465H267.661V156.653Z",
    fill: "#B9D0F1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 140.937H265.703V141.75H267.661V140.937Z",
    fill: "#B9D0F1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 125.22H265.703V126.032H267.661V125.22Z",
    fill: "#B9D0F1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 188.088H268.508V188.9H270.466V188.088Z",
    fill: "#B9D0F1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 172.37H268.508V173.182H270.466V172.37Z",
    fill: "#B9D0F1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 156.653H268.508V157.465H270.466V156.653Z",
    fill: "#B9D0F1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 140.937H268.508V141.75H270.466V140.937Z",
    fill: "#B9D0F1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 125.22H268.508V126.032H270.466V125.22Z",
    fill: "#B9D0F1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 188.088H271.32V188.9H273.278V188.088Z",
    fill: "#B9D0F1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 172.37H271.32V173.182H273.278V172.37Z",
    fill: "#B9D0F1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 156.653H271.32V157.465H273.278V156.653Z",
    fill: "#B9D0F1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 140.937H271.32V141.75H273.278V140.937Z",
    fill: "#B9D0F1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 125.22H271.32V126.032H273.278V125.22Z",
    fill: "#B9D0F1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 189.631H257.273V190.443H259.231V189.631Z",
    fill: "#B9D0F1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 173.914H257.273V174.726H259.231V173.914Z",
    fill: "#B9D0F1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 158.196H257.273V159.008H259.231V158.196Z",
    fill: "#B9D0F1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 142.481H257.273V143.293H259.231V142.481Z",
    fill: "#B9D0F1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 126.764H257.273V127.576H259.231V126.764Z",
    fill: "#B9D0F1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 189.631H260.078V190.443H262.036V189.631Z",
    fill: "#B9D0F1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 173.914H260.078V174.726H262.036V173.914Z",
    fill: "#B9D0F1"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 158.196H260.078V159.008H262.036V158.196Z",
    fill: "#B9D0F1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 142.481H260.078V143.293H262.036V142.481Z",
    fill: "#B9D0F1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 126.764H260.078V127.576H262.036V126.764Z",
    fill: "#B9D0F1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 189.631H262.891V190.443H264.848V189.631Z",
    fill: "#B9D0F1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 173.914H262.891V174.726H264.848V173.914Z",
    fill: "#B9D0F1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 158.196H262.891V159.008H264.848V158.196Z",
    fill: "#B9D0F1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 142.481H262.891V143.293H264.848V142.481Z",
    fill: "#B9D0F1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 126.764H262.891V127.576H264.848V126.764Z",
    fill: "#B9D0F1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 189.631H265.703V190.443H267.661V189.631Z",
    fill: "#B9D0F1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 173.914H265.703V174.726H267.661V173.914Z",
    fill: "#B9D0F1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 158.196H265.703V159.008H267.661V158.196Z",
    fill: "#B9D0F1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 142.481H265.703V143.293H267.661V142.481Z",
    fill: "#B9D0F1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 126.764H265.703V127.576H267.661V126.764Z",
    fill: "#B9D0F1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 189.631H268.508V190.443H270.466V189.631Z",
    fill: "#B9D0F1"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 173.914H268.508V174.726H270.466V173.914Z",
    fill: "#B9D0F1"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 158.196H268.508V159.008H270.466V158.196Z",
    fill: "#B9D0F1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 142.481H268.508V143.293H270.466V142.481Z",
    fill: "#B9D0F1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 126.764H268.508V127.576H270.466V126.764Z",
    fill: "#B9D0F1"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 189.631H271.32V190.443H273.278V189.631Z",
    fill: "#B9D0F1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 173.914H271.32V174.726H273.278V173.914Z",
    fill: "#B9D0F1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 158.196H271.32V159.008H273.278V158.196Z",
    fill: "#B9D0F1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 142.481H271.32V143.293H273.278V142.481Z",
    fill: "#B9D0F1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 126.764H271.32V127.576H273.278V126.764Z",
    fill: "#B9D0F1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 191.175H257.273V191.987H259.231V191.175Z",
    fill: "#B9D0F1"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 175.458H257.273V176.27H259.231V175.458Z",
    fill: "#B9D0F1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 159.74H257.273V160.552H259.231V159.74Z",
    fill: "#B9D0F1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 144.023H257.273V144.835H259.231V144.023Z",
    fill: "#B9D0F1"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 128.307H257.273V129.119H259.231V128.307Z",
    fill: "#B9D0F1"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 191.175H260.078V191.987H262.036V191.175Z",
    fill: "#B9D0F1"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 175.458H260.078V176.27H262.036V175.458Z",
    fill: "#B9D0F1"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 159.74H260.078V160.552H262.036V159.74Z",
    fill: "#B9D0F1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 144.023H260.078V144.835H262.036V144.023Z",
    fill: "#B9D0F1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 128.307H260.078V129.119H262.036V128.307Z",
    fill: "#B9D0F1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 191.175H262.891V191.987H264.848V191.175Z",
    fill: "#B9D0F1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 175.458H262.891V176.27H264.848V175.458Z",
    fill: "#B9D0F1"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 159.74H262.891V160.552H264.848V159.74Z",
    fill: "#B9D0F1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 144.023H262.891V144.835H264.848V144.023Z",
    fill: "#B9D0F1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 128.307H262.891V129.119H264.848V128.307Z",
    fill: "#B9D0F1"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 191.175H265.703V191.987H267.661V191.175Z",
    fill: "#B9D0F1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 175.458H265.703V176.27H267.661V175.458Z",
    fill: "#B9D0F1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 159.74H265.703V160.552H267.661V159.74Z",
    fill: "#B9D0F1"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 144.023H265.703V144.835H267.661V144.023Z",
    fill: "#B9D0F1"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 128.307H265.703V129.119H267.661V128.307Z",
    fill: "#B9D0F1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 191.175H268.508V191.987H270.466V191.175Z",
    fill: "#B9D0F1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 175.458H268.508V176.27H270.466V175.458Z",
    fill: "#B9D0F1"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 159.74H268.508V160.552H270.466V159.74Z",
    fill: "#B9D0F1"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 144.023H268.508V144.835H270.466V144.023Z",
    fill: "#B9D0F1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 128.307H268.508V129.119H270.466V128.307Z",
    fill: "#B9D0F1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 191.175H271.32V191.987H273.278V191.175Z",
    fill: "#B9D0F1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 175.458H271.32V176.27H273.278V175.458Z",
    fill: "#B9D0F1"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 159.74H271.32V160.552H273.278V159.74Z",
    fill: "#B9D0F1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 144.023H271.32V144.835H273.278V144.023Z",
    fill: "#B9D0F1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 128.307H271.32V129.119H273.278V128.307Z",
    fill: "#B9D0F1"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 192.719H257.273V193.531H259.231V192.719Z",
    fill: "#B9D0F1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 177.001H257.273V177.813H259.231V177.001Z",
    fill: "#B9D0F1"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 161.284H257.273V162.096H259.231V161.284Z",
    fill: "#B9D0F1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 145.566H257.273V146.378H259.231V145.566Z",
    fill: "#B9D0F1"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 129.851H257.273V130.663H259.231V129.851Z",
    fill: "#B9D0F1"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 192.719H260.078V193.531H262.036V192.719Z",
    fill: "#B9D0F1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 177.001H260.078V177.813H262.036V177.001Z",
    fill: "#B9D0F1"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 161.284H260.078V162.096H262.036V161.284Z",
    fill: "#B9D0F1"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 145.566H260.078V146.378H262.036V145.566Z",
    fill: "#B9D0F1"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 129.851H260.078V130.663H262.036V129.851Z",
    fill: "#B9D0F1"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 192.719H262.891V193.531H264.848V192.719Z",
    fill: "#B9D0F1"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 177.001H262.891V177.813H264.848V177.001Z",
    fill: "#B9D0F1"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 161.284H262.891V162.096H264.848V161.284Z",
    fill: "#B9D0F1"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 145.566H262.891V146.378H264.848V145.566Z",
    fill: "#B9D0F1"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 129.851H262.891V130.663H264.848V129.851Z",
    fill: "#B9D0F1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 192.719H265.703V193.531H267.661V192.719Z",
    fill: "#B9D0F1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 177.001H265.703V177.813H267.661V177.001Z",
    fill: "#B9D0F1"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 161.284H265.703V162.096H267.661V161.284Z",
    fill: "#B9D0F1"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 145.566H265.703V146.378H267.661V145.566Z",
    fill: "#B9D0F1"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 129.851H265.703V130.663H267.661V129.851Z",
    fill: "#B9D0F1"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 192.719H268.508V193.531H270.466V192.719Z",
    fill: "#B9D0F1"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 177.001H268.508V177.813H270.466V177.001Z",
    fill: "#B9D0F1"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 161.284H268.508V162.096H270.466V161.284Z",
    fill: "#B9D0F1"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 145.566H268.508V146.378H270.466V145.566Z",
    fill: "#B9D0F1"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 129.851H268.508V130.663H270.466V129.851Z",
    fill: "#B9D0F1"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 192.719H271.32V193.531H273.278V192.719Z",
    fill: "#B9D0F1"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 177.001H271.32V177.813H273.278V177.001Z",
    fill: "#B9D0F1"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 161.284H271.32V162.096H273.278V161.284Z",
    fill: "#B9D0F1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 145.566H271.32V146.378H273.278V145.566Z",
    fill: "#B9D0F1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 129.851H271.32V130.663H273.278V129.851Z",
    fill: "#B9D0F1"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 194.26H257.273V195.072H259.231V194.26Z",
    fill: "#B9D0F1"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 178.545H257.273V179.357H259.231V178.545Z",
    fill: "#B9D0F1"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 162.827H257.273V163.639H259.231V162.827Z",
    fill: "#B9D0F1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 147.11H257.273V147.922H259.231V147.11Z",
    fill: "#B9D0F1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 131.392H257.273V132.204H259.231V131.392Z",
    fill: "#B9D0F1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 194.26H260.078V195.072H262.036V194.26Z",
    fill: "#B9D0F1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 178.545H260.078V179.357H262.036V178.545Z",
    fill: "#B9D0F1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 162.827H260.078V163.639H262.036V162.827Z",
    fill: "#B9D0F1"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 147.11H260.078V147.922H262.036V147.11Z",
    fill: "#B9D0F1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 131.392H260.078V132.204H262.036V131.392Z",
    fill: "#B9D0F1"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 194.26H262.891V195.072H264.848V194.26Z",
    fill: "#B9D0F1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 178.545H262.891V179.357H264.848V178.545Z",
    fill: "#B9D0F1"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 162.827H262.891V163.639H264.848V162.827Z",
    fill: "#B9D0F1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 147.11H262.891V147.922H264.848V147.11Z",
    fill: "#B9D0F1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 131.392H262.891V132.204H264.848V131.392Z",
    fill: "#B9D0F1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 194.26H265.703V195.072H267.661V194.26Z",
    fill: "#B9D0F1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 178.545H265.703V179.357H267.661V178.545Z",
    fill: "#B9D0F1"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 162.827H265.703V163.639H267.661V162.827Z",
    fill: "#B9D0F1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 147.11H265.703V147.922H267.661V147.11Z",
    fill: "#B9D0F1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 131.392H265.703V132.204H267.661V131.392Z",
    fill: "#B9D0F1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 194.26H268.508V195.072H270.466V194.26Z",
    fill: "#B9D0F1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 178.545H268.508V179.357H270.466V178.545Z",
    fill: "#B9D0F1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 162.827H268.508V163.639H270.466V162.827Z",
    fill: "#B9D0F1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 147.11H268.508V147.922H270.466V147.11Z",
    fill: "#B9D0F1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 131.392H268.508V132.204H270.466V131.392Z",
    fill: "#B9D0F1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 194.26H271.32V195.072H273.278V194.26Z",
    fill: "#B9D0F1"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 178.545H271.32V179.357H273.278V178.545Z",
    fill: "#B9D0F1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 162.827H271.32V163.639H273.278V162.827Z",
    fill: "#B9D0F1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 147.11H271.32V147.922H273.278V147.11Z",
    fill: "#B9D0F1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 131.392H271.32V132.204H273.278V131.392Z",
    fill: "#B9D0F1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 188.088H277V188.9H278.958V188.088Z",
    fill: "#E06B6C"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 172.37H277V173.182H278.958V172.37Z",
    fill: "#E06B6C"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 156.653H277V157.465H278.958V156.653Z",
    fill: "#E06B6C"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 140.937H277V141.75H278.958V140.937Z",
    fill: "#E06B6C"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 125.22H277V126.032H278.958V125.22Z",
    fill: "#E06B6C"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 188.088H279.812V188.9H281.77V188.088Z",
    fill: "#E06B6C"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 172.37H279.812V173.182H281.77V172.37Z",
    fill: "#E06B6C"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 156.653H279.812V157.465H281.77V156.653Z",
    fill: "#E06B6C"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 140.937H279.812V141.75H281.77V140.937Z",
    fill: "#E06B6C"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 125.22H279.812V126.032H281.77V125.22Z",
    fill: "#E06B6C"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 188.088H282.617V188.9H284.575V188.088Z",
    fill: "#E06B6C"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 172.37H282.617V173.182H284.575V172.37Z",
    fill: "#E06B6C"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 156.653H282.617V157.465H284.575V156.653Z",
    fill: "#E06B6C"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 140.937H282.617V141.75H284.575V140.937Z",
    fill: "#E06B6C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 125.22H282.617V126.032H284.575V125.22Z",
    fill: "#E06B6C"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 188.088H290.148V188.9H292.106V188.088Z",
    fill: "#E06B6C"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 172.37H290.148V173.182H292.106V172.37Z",
    fill: "#E06B6C"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 156.653H290.148V157.465H292.106V156.653Z",
    fill: "#E06B6C"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 140.937H290.148V141.75H292.106V140.937Z",
    fill: "#E06B6C"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 125.22H290.148V126.032H292.106V125.22Z",
    fill: "#E06B6C"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 188.088H292.961V188.9H294.919V188.088Z",
    fill: "#E06B6C"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 172.37H292.961V173.182H294.919V172.37Z",
    fill: "#E06B6C"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 156.653H292.961V157.465H294.919V156.653Z",
    fill: "#E06B6C"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 140.937H292.961V141.75H294.919V140.937Z",
    fill: "#E06B6C"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 125.22H292.961V126.032H294.919V125.22Z",
    fill: "#E06B6C"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 188.088H295.766V188.9H297.723V188.088Z",
    fill: "#E06B6C"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 172.37H295.766V173.182H297.723V172.37Z",
    fill: "#E06B6C"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 156.653H295.766V157.465H297.723V156.653Z",
    fill: "#E06B6C"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 140.937H295.766V141.75H297.723V140.937Z",
    fill: "#E06B6C"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 125.22H295.766V126.032H297.723V125.22Z",
    fill: "#E06B6C"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 105.522H309.39C310.047 105.522 310.588 106.061 310.588 106.721V117.37C310.588 118.028 310.05 118.569 309.39 118.569H253.589C252.931 118.569 252.391 118.031 252.391 117.37V106.721C252.391 106.063 252.929 105.522 253.589 105.522Z",
    fill: "#2A4589"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.589 89.805H309.39C310.047 89.805 310.588 90.3433 310.588 91.0036V101.653C310.588 102.311 310.05 102.852 309.39 102.852H253.589C252.931 102.852 252.391 102.313 252.391 101.653V91.0036C252.391 90.3456 252.929 89.805 253.589 89.805Z",
    fill: "#2A4589"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 109.502H254.453V110.315H256.411V109.502Z",
    fill: "#B9D0F1"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 93.785H254.453V94.5971H256.411V93.785Z",
    fill: "#B9D0F1"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 111.046H254.453V111.858H256.411V111.046Z",
    fill: "#B9D0F1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 95.3287H254.453V96.1408H256.411V95.3287Z",
    fill: "#B9D0F1"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 112.59H254.453V113.402H256.411V112.59Z",
    fill: "#B9D0F1"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 96.8724H254.453V97.6845H256.411V96.8724Z",
    fill: "#B9D0F1"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 114.133H254.453V114.946H256.411V114.133Z",
    fill: "#B9D0F1"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 98.416H254.453V99.2281H256.411V98.416Z",
    fill: "#B9D0F1"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 115.677H254.453V116.489H256.411V115.677Z",
    fill: "#B9D0F1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M256.411 99.9597H254.453V100.772H256.411V99.9597Z",
    fill: "#B9D0F1"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 109.502H257.273V110.315H259.231V109.502Z",
    fill: "#B9D0F1"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 93.785H257.273V94.5971H259.231V93.785Z",
    fill: "#B9D0F1"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 109.502H260.078V110.315H262.036V109.502Z",
    fill: "#B9D0F1"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 93.785H260.078V94.5971H262.036V93.785Z",
    fill: "#B9D0F1"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 109.502H262.891V110.315H264.848V109.502Z",
    fill: "#B9D0F1"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 93.785H262.891V94.5971H264.848V93.785Z",
    fill: "#B9D0F1"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 109.502H265.703V110.315H267.661V109.502Z",
    fill: "#B9D0F1"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 93.785H265.703V94.5971H267.661V93.785Z",
    fill: "#B9D0F1"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 109.502H268.508V110.315H270.466V109.502Z",
    fill: "#B9D0F1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 93.785H268.508V94.5971H270.466V93.785Z",
    fill: "#B9D0F1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 109.502H271.32V110.315H273.278V109.502Z",
    fill: "#B9D0F1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 93.785H271.32V94.5971H273.278V93.785Z",
    fill: "#B9D0F1"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 111.046H257.273V111.858H259.231V111.046Z",
    fill: "#B9D0F1"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 95.3287H257.273V96.1408H259.231V95.3287Z",
    fill: "#B9D0F1"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 111.046H260.078V111.858H262.036V111.046Z",
    fill: "#B9D0F1"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 95.3287H260.078V96.1408H262.036V95.3287Z",
    fill: "#B9D0F1"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 111.046H262.891V111.858H264.848V111.046Z",
    fill: "#B9D0F1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 95.3287H262.891V96.1408H264.848V95.3287Z",
    fill: "#B9D0F1"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 111.046H265.703V111.858H267.661V111.046Z",
    fill: "#B9D0F1"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 95.3287H265.703V96.1408H267.661V95.3287Z",
    fill: "#B9D0F1"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 111.046H268.508V111.858H270.466V111.046Z",
    fill: "#B9D0F1"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 95.3287H268.508V96.1408H270.466V95.3287Z",
    fill: "#B9D0F1"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 111.046H271.32V111.858H273.278V111.046Z",
    fill: "#B9D0F1"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 95.3287H271.32V96.1408H273.278V95.3287Z",
    fill: "#B9D0F1"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 112.59H257.273V113.402H259.231V112.59Z",
    fill: "#B9D0F1"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 96.8724H257.273V97.6845H259.231V96.8724Z",
    fill: "#B9D0F1"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 112.59H260.078V113.402H262.036V112.59Z",
    fill: "#B9D0F1"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 96.8724H260.078V97.6845H262.036V96.8724Z",
    fill: "#B9D0F1"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 112.59H262.891V113.402H264.848V112.59Z",
    fill: "#B9D0F1"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 96.8724H262.891V97.6845H264.848V96.8724Z",
    fill: "#B9D0F1"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 112.59H265.703V113.402H267.661V112.59Z",
    fill: "#B9D0F1"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 96.8724H265.703V97.6845H267.661V96.8724Z",
    fill: "#B9D0F1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 112.59H268.508V113.402H270.466V112.59Z",
    fill: "#B9D0F1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 96.8724H268.508V97.6845H270.466V96.8724Z",
    fill: "#B9D0F1"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 112.59H271.32V113.402H273.278V112.59Z",
    fill: "#B9D0F1"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 96.8724H271.32V97.6845H273.278V96.8724Z",
    fill: "#B9D0F1"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 114.133H257.273V114.946H259.231V114.133Z",
    fill: "#B9D0F1"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 98.416H257.273V99.2281H259.231V98.416Z",
    fill: "#B9D0F1"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 114.133H260.078V114.946H262.036V114.133Z",
    fill: "#B9D0F1"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 98.416H260.078V99.2281H262.036V98.416Z",
    fill: "#B9D0F1"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 114.133H262.891V114.946H264.848V114.133Z",
    fill: "#B9D0F1"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 98.416H262.891V99.2281H264.848V98.416Z",
    fill: "#B9D0F1"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 114.133H265.703V114.946H267.661V114.133Z",
    fill: "#B9D0F1"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 98.416H265.703V99.2281H267.661V98.416Z",
    fill: "#B9D0F1"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 114.133H268.508V114.946H270.466V114.133Z",
    fill: "#B9D0F1"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 98.416H268.508V99.2281H270.466V98.416Z",
    fill: "#B9D0F1"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 114.133H271.32V114.946H273.278V114.133Z",
    fill: "#B9D0F1"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 98.416H271.32V99.2281H273.278V98.416Z",
    fill: "#B9D0F1"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 115.677H257.273V116.489H259.231V115.677Z",
    fill: "#B9D0F1"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M259.231 99.9597H257.273V100.772H259.231V99.9597Z",
    fill: "#B9D0F1"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 115.677H260.078V116.489H262.036V115.677Z",
    fill: "#B9D0F1"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M262.036 99.9597H260.078V100.772H262.036V99.9597Z",
    fill: "#B9D0F1"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 115.677H262.891V116.489H264.848V115.677Z",
    fill: "#B9D0F1"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M264.848 99.9597H262.891V100.772H264.848V99.9597Z",
    fill: "#B9D0F1"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 115.677H265.703V116.489H267.661V115.677Z",
    fill: "#B9D0F1"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M267.661 99.9597H265.703V100.772H267.661V99.9597Z",
    fill: "#B9D0F1"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 115.677H268.508V116.489H270.466V115.677Z",
    fill: "#B9D0F1"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M270.466 99.9597H268.508V100.772H270.466V99.9597Z",
    fill: "#B9D0F1"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 115.677H271.32V116.489H273.278V115.677Z",
    fill: "#B9D0F1"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M273.278 99.9597H271.32V100.772H273.278V99.9597Z",
    fill: "#B9D0F1"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 109.502H277V110.315H278.958V109.502Z",
    fill: "#E06B6C"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M278.958 93.785H277V94.5971H278.958V93.785Z",
    fill: "#E06B6C"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 109.502H279.812V110.315H281.77V109.502Z",
    fill: "#E06B6C"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M281.77 93.785H279.812V94.5971H281.77V93.785Z",
    fill: "#E06B6C"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 109.502H282.617V110.315H284.575V109.502Z",
    fill: "#E06B6C"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M284.575 93.785H282.617V94.5971H284.575V93.785Z",
    fill: "#E06B6C"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 109.502H290.148V110.315H292.106V109.502Z",
    fill: "#E06B6C"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M292.106 93.785H290.148V94.5971H292.106V93.785Z",
    fill: "#E06B6C"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 109.502H292.961V110.315H294.919V109.502Z",
    fill: "#E06B6C"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M294.919 93.785H292.961V94.5971H294.919V93.785Z",
    fill: "#E06B6C"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 109.502H295.766V110.315H297.723V109.502Z",
    fill: "#E06B6C"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M297.723 93.785H295.766V94.5971H297.723V93.785Z",
    fill: "#E06B6C"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.27 125.857H98.7724C99.5132 125.857 100.121 126.465 100.121 127.205C100.121 127.946 99.5132 128.553 98.7724 128.553H63.27C62.5292 128.553 61.9219 127.946 61.9219 127.205C61.9219 126.465 62.5292 125.857 63.27 125.857Z",
    fill: "#7BA9E3"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.27 133.495H93.5409C94.2817 133.495 94.889 134.102 94.889 134.843C94.889 135.584 94.2817 136.191 93.5409 136.191H63.27C62.5292 136.191 61.9219 135.584 61.9219 134.843C61.9219 134.102 62.5292 133.495 63.27 133.495Z",
    fill: "#7BA9E3"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.27 141.133H94.9327C95.6735 141.133 96.2809 141.74 96.2809 142.481C96.2809 143.222 95.6735 143.829 94.9327 143.829H63.27C62.5292 143.829 61.9219 143.222 61.9219 142.481C61.9219 141.74 62.5292 141.133 63.27 141.133Z",
    fill: "#7BA9E3"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.27 148.771H82.811C83.5518 148.771 84.1592 149.378 84.1592 150.119C84.1592 150.86 83.5518 151.467 82.811 151.467H63.27C62.5292 151.467 61.9219 150.86 61.9219 150.119C61.9219 149.378 62.5292 148.771 63.27 148.771Z",
    fill: "#7BA9E3"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.27 156.409H98.7724C99.5132 156.409 100.121 157.016 100.121 157.757C100.121 158.498 99.5132 159.105 98.7724 159.105H63.27C62.5292 159.105 61.9219 158.498 61.9219 157.757C61.9219 157.016 62.5292 156.409 63.27 156.409Z",
    fill: "#7BA9E3"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8977 103.376H66.587C67.5234 103.376 68.2895 104.142 68.2895 105.078V110.413C68.2895 111.35 67.5234 112.116 66.587 112.116H60.8977C59.9614 112.116 59.1953 111.35 59.1953 110.413V105.078C59.1953 104.142 59.9614 103.376 60.8977 103.376Z",
    fill: "#7BA9E3"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1165 103.376H104.713C105.65 103.376 106.416 104.142 106.416 105.078V110.413C106.416 111.35 105.65 112.116 104.713 112.116H72.1165C71.1802 112.116 70.4141 111.35 70.4141 110.413V105.078C70.4141 104.142 71.1802 103.376 72.1165 103.376Z",
    fill: "#7BA9E3"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.082 87.3917L194.098 76.9356H200.294L191.807 65.5501L183.32 76.9356H189.518L189.502 87.3917H194.082Z",
    fill: "#B1D2FC"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.924 86.9109L257.94 76.9356H264.135L255.649 65.5501L247.164 76.9356H253.36L253.343 86.9109H257.924Z",
    fill: "#B1D2FC"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M334.702 178.046C334.633 178.602 334.424 178.86 334.553 179.401C334.647 179.794 334.732 180.572 334.7 180.979C334.675 181.296 334.479 182.433 333.925 182.407C333.862 182.405 333.816 182.384 333.773 182.336C333.669 182.58 333.294 182.355 333.161 182.272C333.032 182.502 332.613 182.334 332.498 182.189C332.342 182.575 331.592 182.088 331.369 181.49C331.067 181.204 331.116 180.298 331.185 179.978C331.166 179.964 331.258 179.776 331.389 179.534C331.619 179.108 331.965 178.513 332.029 178.393C332.178 178.11 332.411 177.873 332.397 177.544L334.7 178.046H334.702Z",
    fill: "#F3ADBE"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.943 156.186C323.174 154.589 323.766 151.46 325.392 150.756C325.822 150.57 327.035 149.986 327.826 150.43C330.621 151.996 334.491 161.935 334.928 165.593C335.287 168.595 335.715 175.892 334.62 179.835C334.383 180.687 333.295 180.224 332.915 179.992C331.96 179.658 331.974 173.109 330.067 166.702C328.496 161.417 324.631 157.619 323.94 156.183",
    fill: "#FCA700"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.114 157.527L299.419 156.666L298.966 154.32C298.982 154.032 298.747 152.291 298.381 152.916C298.124 153.356 297.866 154.508 297.816 154.502C296.81 153.14 295.227 151.739 295.168 151.727C294.332 151.573 295.6 153.39 295.777 153.699C295.862 153.846 295.269 153.197 295.184 153.963C295.158 154.2 295.317 154.193 295.411 154.472C295.471 154.649 295.02 153.989 294.947 154.601C294.898 155.005 295.013 155.01 295.108 155.242C295.135 155.309 294.961 155.157 294.852 155.206C294.765 155.245 294.728 155.475 294.816 155.624C295.934 157.543 296.78 156.749 298.023 159.204C298.738 160.616 300.079 158.116 300.114 157.522",
    fill: "#F3ADBE"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.232 174.335C307.897 178.414 312.915 201.592 313.782 215.646L313.646 215.632C313.646 215.632 313.538 216.845 312.606 217.353C311.675 217.862 308.247 218.28 307.695 218.807C307.297 219.187 306.637 220.717 312.08 220.574C315.947 220.473 317.815 220.804 318.229 220.176C318.549 219.693 318.436 217.319 318.367 216.251H318.39C318.892 206.644 317.889 197.771 319.766 186.477C321.252 193.119 322.934 199.376 323.918 202.894C324.512 205.015 327.535 215.158 327.245 217.257C327.181 217.724 324.99 217.933 324.068 218.676C323.681 219.044 322.966 220.588 326.716 220.556C330.466 220.523 332.274 220.779 332.677 220.171C333.054 219.603 330.694 203.016 330.475 200.784C329.506 190.922 329.205 180.017 327.91 173.594H327.908C327.238 146.806 313.004 153.71 314.286 169.929C314.431 171.763 310.876 171.811 310.235 174.339",
    fill: "#1B326B"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M321.503 137.381C321.503 137.381 317.801 135.998 316.094 138.816C315.666 139.52 315.001 139.631 315.015 140.588C315.02 140.905 315.015 141.621 314.909 142.23C314.822 142.741 314.428 143.496 314.346 143.907C314.242 144.421 315.006 144.694 315.022 144.92C315.151 146.71 315.259 147.57 316.082 147.876C318.162 148.168 321.086 148.295 322.043 146.532C322.998 144.77 323.861 142.221 323.819 140.519C323.778 138.816 322.476 137.871 321.505 137.381",
    fill: "#F3ADBE"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M317.043 147.793C317.043 147.793 317.193 148.764 316.946 149.24C316.7 149.719 321.603 149.73 321.603 149.73C321.603 149.73 322.001 147.131 322.755 144.936C323.51 142.739 317.045 147.793 317.045 147.793",
    fill: "#F3ADBE"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.788 147.326C319.872 147.057 319.007 146.781 318.243 145.939C317.972 145.64 317.537 143.075 317.388 143.022C316.81 142.819 316.536 144.805 316.536 144.805C316.451 144.701 316.145 144.616 316.076 144.287C316.046 144.142 316.24 143.323 316.113 143.114C316.021 142.962 315.393 142.419 315.255 142.217C314.144 140.565 312.872 138.78 314.374 137.503C314.436 137.45 314.85 137.158 315.329 137.151C315.989 137.141 316.511 136.905 316.776 136.78C320.422 135.057 327.565 137.689 323.797 145.053C323.27 146.084 321.653 147.236 320.788 147.326Z",
    fill: "#1B326B"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M316.656 149.183C316.656 149.183 316.672 148.269 317.086 148.182C317.501 148.095 321.922 147.807 322.431 148.007L322.486 149.169C322.486 149.169 321.186 149.562 316.659 149.183",
    fill: "#D1F2FF"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M316.83 143.592C316.908 143.268 317.704 141.941 318.019 142.934C318.337 143.926 317.543 145.263 317.099 145.148C316.657 145.032 316.632 144.416 316.827 143.592",
    fill: "#F3ADBE"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.527 148.937C324.425 148.937 327.13 149.516 328.278 150.862C329.923 152.79 329.516 176.297 329.015 179.302C327.379 183.797 313.868 182.274 309.648 179.888L310.012 152.523C313.03 147.917 317.756 148.937 322.525 148.937",
    fill: "#FCA700"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.687 167.357C305.352 168.512 298.602 161.645 298.022 159.659C297.445 157.672 299.766 156.494 299.766 156.494C299.766 156.494 305.023 160.817 305.918 160.52C306.594 160.294 308.494 154.499 310.282 152.137C312.168 150.413 315.796 161.898 307.687 167.359",
    fill: "#FCA700"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7267 216.403L97.0189 213.302L93.9062 213.378L93.9362 216.928L96.7267 216.403Z",
    fill: "#F4AF8F"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8844 216.143C97.4871 218.296 99.1965 219.235 98.0784 220.579H92.3799C92.3707 220.553 92.3615 220.526 92.3523 220.496C92.2971 220.312 92.0302 220.236 92.2096 219.562C92.5409 218.312 93.5095 216.392 93.843 216.293C94.5033 216.097 95.4442 216.649 96.8844 216.145",
    fill: "#1B326B"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.442 219.532L98.4489 219.769C98.4328 220.102 98.2993 220.397 98.0164 220.578H92.38C91.9452 220.167 92.1292 219.794 92.2097 219.562L98.442 219.534V219.532Z",
    fill: "#140505"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.273 173.41L102.939 186.953L101.237 195.017L97.4594 214.655C97.4594 214.655 96.6588 215.02 95.382 214.944C94.1052 214.871 93.4588 214.682 93.4588 214.682C93.4311 208.882 93.4588 201.521 94.0845 194.12C94.6113 187.917 92.6282 184.598 93.0101 177.758C93.1229 175.738 95.2992 170.012 95.2716 170.086L106.275 173.412L106.273 173.41Z",
    fill: "#1B326B"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.624 176.044L104.768 179.516C100.395 180.061 95.8237 179.688 93.017 178.925C93.0124 178.531 93.0101 178.14 93.0078 177.758C93.0078 177.358 93.0952 176.81 93.2379 176.194C97.2041 176.171 103.68 176.127 104.311 176.083C104.52 176.07 105.003 176.056 105.624 176.046",
    fill: "#12143C"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.484 216.403L110.472 213.196L107.359 213.27L107.695 216.928L110.484 216.403Z",
    fill: "#F4AF8F"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.688 215.717C112.232 217.549 115.556 217.94 116.946 218.398C118.073 218.768 118.613 220.017 117.739 220.576H107.088C107.078 220.551 107.069 220.523 107.06 220.493C106.901 219.967 106.487 216.207 107.596 216.29C108.284 216.343 109.151 216.511 110.69 215.717",
    fill: "#1B326B"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.262 216.267C112.691 217.427 114.904 217.859 116.298 218.214C116.222 218.506 116.181 218.766 115.247 218.786C113.834 218.819 112.049 218.02 111.393 217.556C110.912 217.215 111.078 216.649 111.262 216.27",
    fill: "#140505"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.169 219.532L118.176 219.769C118.16 220.102 118.027 220.397 117.744 220.578H107.092C107.083 220.553 107.074 220.526 107.065 220.496C107.035 220.392 106.959 219.858 106.922 219.562L118.169 219.534V219.532Z",
    fill: "#140505"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.747 172.681L112.003 191.706L110.784 214.643C110.784 214.643 109.291 214.965 108.012 214.892C106.733 214.818 106.967 214.671 106.967 214.671L103.976 193.291C103.976 193.291 103.3 188.423 101.717 184.63C100.574 181.89 99.1728 181.101 99.3799 177.917C99.5939 174.62 99.3178 172.064 99.771 170.925C100.224 169.787 102.49 170.244 102.49 170.244L110.752 172.683L110.747 172.681Z",
    fill: "#1B326B"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.94 175.998L111.071 178.278C108.414 179.081 104.742 179.911 99.4627 179.76C99.3476 179.203 99.3269 178.694 99.3776 177.915C99.4167 177.298 99.4397 176.709 99.4535 176.148C101.904 176.127 103.969 176.104 104.31 176.079C105.067 176.026 109.463 176.003 110.938 175.996",
    fill: "#12143C"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.641 198.079L103.972 193.291C103.972 193.291 103.604 190.639 102.773 187.722L103.406 183.185L104.722 194.564L104.641 198.079Z",
    fill: "#12143C"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.054 155.73C106.736 159.535 108.02 163.262 112.95 164.054C116.442 164.192 122.746 161.99 122.288 160.782C121.789 159.466 123.94 159.034 121.934 159.048C119.267 159.008 114.057 159.059 113.456 159.008C112.888 158.962 109.794 150.936 105.372 149.286C104.96 149.015 103.863 153.885 105.054 155.73Z",
    fill: "#F79F2D"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.105 159.114C128.008 159.273 127.999 159.508 127.826 159.738C127.277 160.467 125.809 161.564 122.657 161.065C122.507 161.042 122.1 161.07 121.937 161.042C121.84 160.736 121.769 159.784 122.139 158.916C123.294 159.052 128.615 158.502 128.105 159.114Z",
    fill: "#F4B1B1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.031 159.761C108.207 161.594 109.937 163.57 112.944 164.054C114.915 164.132 117.089 163.617 119.418 162.807C117.108 162.411 115.127 163.435 112.9 162.763C110.862 162.146 107.317 156.501 107.317 156.501C107.317 156.501 107.388 158.979 107.031 159.761Z",
    fill: "#EF7800"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0772 163.633C92.673 167.392 93.3149 173.468 92.7466 178.128C100.421 179.539 106.677 178.752 111.287 177.342C110.799 171.622 109.488 153.857 105.368 149.286C100.297 147.8 94.6101 148.442 91.8264 150.954C91.41 151.32 90.9867 151.831 90.5703 152.447V166.283C91.1547 165.406 91.6815 164.461 92.0772 163.633Z",
    fill: "#F79F2D"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M102.312 148.649C100.561 148.338 98.4541 147.998 95.7188 149.003C96.3606 152.447 98.5139 152.873 100.159 152.785C102.386 152.666 103.235 150.655 102.312 148.649Z",
    fill: "#EF7800"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1559 171.68C94.1559 171.68 100.917 172.106 102.148 171.892C103.379 171.68 103.804 171.34 103.804 171.34C104.973 171.595 105.907 171.597 106.62 171.461C107.223 171.346 108.64 170.532 107.656 170.109L104.888 168.919L98.6903 168.623L94.9542 168.813L93.6797 170.003L94.1582 171.68H94.1559Z",
    fill: "#EF7800"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7788 157.789C94.7788 157.789 95.2804 162.386 95.683 163.828C96.2374 165.814 101.786 166.419 102.884 168.595L93.2697 169.557C93.2697 169.557 91.2751 166.097 91.466 165.183C91.657 164.27 94.7788 157.787 94.7788 157.787",
    fill: "#EF7800"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5528 178.269C100.586 179.437 106.39 178.757 110.779 177.493C109.79 177.622 108.343 177.822 106.153 177.958C100.887 178.289 97.8664 177.346 95.361 173.221C94.358 171.57 93.9071 163.541 93.348 160.474C92.9684 161.695 92.628 162.514 92.0781 163.635C92.6326 167.456 93.2606 173.914 92.7476 178.131C93.0168 178.179 93.2836 178.227 93.5505 178.271L93.5528 178.269Z",
    fill: "#EF7800"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.381 144.986C102.9 146.04 102.2 146.866 101.404 147.285L101.489 148.787C103.291 151.831 97.2518 153.186 97.0379 148.886L97.3462 148.516L97.337 146.385C97.2104 146.383 96.2626 145.891 95.9842 145.817C95.7059 145.743 95.2803 145.226 95.232 144.667C95.1836 144.108 96.0579 144.255 96.0579 144.255C94.9536 142.856 93.7205 141.727 95.2135 140.376C96.7066 139.023 100.222 138.135 100.222 138.135L102.327 137.316C102.083 138.062 102.361 140.33 102.966 141.842C103.509 143.199 104.027 143.574 103.383 144.989",
    fill: "#F4B1B1"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3516 146.643C99.0969 147.816 99.9597 149.029 101.487 148.789L101.402 147.287C100.723 147.423 100.054 147.393 98.3516 146.643Z",
    fill: "#E06B6C"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5106 216.083H96.0934C96.3096 216.083 96.4868 216.26 96.4868 216.477V218.048C96.4868 218.264 96.3096 218.441 96.0934 218.441H94.5106C94.2943 218.441 94.1172 218.264 94.1172 218.048V216.477C94.1172 216.26 94.2943 216.083 94.5106 216.083Z",
    fill: "#140505"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2993 155.551C93.027 153.294 91.5455 150.275 90.3308 152.864C88.0095 157.805 88.2212 167.686 90.1651 169.621C92.1459 171.551 101.666 171.924 102.57 171.296C103.635 170.557 104.445 169.237 102.719 168.351C101.645 167.7 100.347 167.509 98.5116 167.205C95.6658 166.731 94.6351 166.221 94.3591 163.702C94.0554 160.909 95.4794 157.646 94.297 155.551",
    fill: "#F79F2D"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.431 168.234C104.76 167.935 106.085 166.771 106.504 166.715C106.718 166.688 106.709 166.764 106.709 166.879C106.709 166.98 106.619 167.192 106.516 167.304C106.297 167.541 106.147 168.105 106.009 168.215C107.473 169.322 109.927 168.779 109.833 169.745C109.709 169.895 108.717 170.456 108.499 170.668C107.808 171.342 107.397 171.6 103.833 170.801C103.665 170.764 103.196 170.753 103.012 170.709C102.927 170.394 102.924 169.439 103.421 168.609L104.431 168.234Z",
    fill: "#F6C4C5"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.411 140.758C100.628 141.671 98.5758 140.588 97.5382 141.809C97.0252 142.414 97.0758 143.289 97.6509 144.637C97.8212 145.035 98.0466 145.327 97.3772 145.016C97.0689 144.874 96.5628 144.674 96.3879 144.814C96.0014 145.124 96.197 145.78 96.5053 145.992C96.6433 146.086 96.9033 146.226 96.9033 146.226C94.5061 145.771 93.5076 143.608 93.5398 141.867C93.5513 141.276 93.618 140.751 93.7285 140.284C93.6802 140.123 93.6525 139.953 93.6525 139.776C93.6525 139.019 94.1334 138.382 94.7936 138.181C94.9156 137.392 95.5689 136.79 96.3557 136.79C96.5927 136.79 96.8181 136.845 97.0183 136.941L97.0965 136.921C97.3841 136.426 97.9247 136.092 98.5436 136.092C98.9761 136.092 99.3718 136.256 99.6685 136.525C100.106 135.931 100.766 135.552 101.504 135.552C102.82 135.552 103.885 136.75 103.885 138.23C103.885 139.154 103.467 139.971 102.832 140.452C102.703 140.565 102.563 140.666 102.406 140.758",
    fill: "#1B326B"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.409 158.445H112.258V159.041C112.258 159.37 112.527 159.636 112.854 159.636H123.811C124.14 159.636 124.407 159.367 124.407 159.041V158.445H124.409Z",
    fill: "#1B326B"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.575 149.447H118.596C118.125 149.447 117.826 149.848 117.738 150.317L117.004 154.219L116.188 158.551H129.765L131.316 150.195C131.392 149.79 130.982 149.447 130.578 149.447",
    fill: "#1B326B"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.992 149.447H119.013C118.542 149.447 118.243 149.848 118.155 150.317L116.625 158.445H116.605L116.506 159.041C116.453 159.365 116.775 159.636 117.102 159.636H129.511C129.838 159.636 130.058 159.365 130.107 159.041L130.18 158.551L131.731 150.197C131.807 149.792 131.397 149.45 130.99 149.45",
    fill: "#718BC6"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.55 153.945C124.198 153.86 123.835 154.129 123.736 154.541C123.637 154.955 123.842 155.357 124.194 155.443C124.546 155.528 124.909 155.258 125.008 154.847C125.107 154.433 124.902 154.03 124.55 153.945Z",
    fill: "#D1E3F6"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1731 220.043C28.4714 219.594 24.5903 217.277 23.9117 216.792C8.41963 205.726 -1.3693 185.279 0.155981 166.336L0.533274 161.666L5.15972 160.936C13.2784 159.66 19.2438 157.207 26.3779 153.186L29.2996 151.539L32.2213 153.186C39.3922 157.23 45.3415 159.586 53.4924 160.946L58.0705 161.709L58.4432 166.336C60.0352 186.112 49.2984 207.528 32.6124 218.195L29.1777 220.043H29.1731Z",
    fill: "#B1D2FC"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3459 161.247C22.2233 165.264 16.4972 167.557 8.56943 168.804C7.265 184.996 16.3822 202.137 29.3459 210.369C42.3096 202.135 51.4267 184.996 50.1223 168.804C42.0473 167.458 36.4684 165.264 29.3459 161.247Z",
    fill: "#2A4589"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3438 208.103C36.1833 203.002 41.5184 195.562 44.6701 187.715C46.8534 182.274 48.1026 176.385 48.0336 170.509C44.8266 169.858 41.6748 169.002 38.5989 167.868C35.408 166.692 32.3391 165.238 29.3438 163.635V208.103Z",
    fill: "#4663AA"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3491 170.323C22.0793 170.323 16.1875 176.214 16.1875 183.484C16.1875 190.754 22.0793 196.646 29.3491 196.646C36.6189 196.646 42.5106 190.754 42.5106 183.484C42.5106 176.214 36.6189 170.323 29.3491 170.323Z",
    fill: "#77BB2C"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0422 185.449L34.9815 178.08C35.789 177.33 37.0566 177.376 37.8066 178.184C38.5565 178.991 38.5128 180.259 37.703 181.009L28.2408 189.792L28.2109 189.815C27.385 190.538 26.1174 190.453 25.3927 189.629L21.4771 185.166C20.7524 184.34 20.8376 183.07 21.6635 182.348C22.4894 181.625 23.757 181.71 24.4817 182.534L27.0399 185.451L27.0422 185.449Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6219_98153",
    x1: 222.31,
    y1: 58.5196,
    x2: 222.31,
    y2: 2.23155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6219_98153",
    x1: 213.701,
    y1: 0,
    x2: 213.701,
    y2: -23.4244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F8FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6219_98153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 357,
    height: 221.126,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessDataMigration);
export default __webpack_public_path__ + "static/media/seamless_data_migration.87aadf4cdd1c1a223a2627ccc0528841.svg";
export { ForwardRef as ReactComponent };